import request from '@/utils/request_2'

// 查询会员列表
export function listMember(data) {
  return request({
    url: '/system/member/list',
    method: 'post',
    data: data
  })
}

// 查询会员详细
export function getMember(id) {
  return request({
    url: '/system/member/' + id,
    method: 'get'
  })
}

// 新增会员
export function addMember(data) {
  return request({
    url: '/system/member',
    method: 'post',
    data: data
  })
}

// 修改会员
export function updateMember(data) {
  return request({
    url: '/system/member/saveOrUpdate',
    method: 'post',
    data: data
  })
}

// 删除会员
export function delMember(id) {
  return request({
    url: '/system/member/' + id,
    method: 'delete'
  })
}

// 查询家庭成员
export function getFamilyMember(id) {
  return request({
    url: 'system/member/findFamilyByMemberId/' + id,
    method: 'get'
  })
}
// 添加家庭成员
export function addFamily(data) {
  return request({
    url: 'system/member/addFamilyMember',
    method: 'post',
    data: data
  })
}
// 删除家庭成员
export function deleteFamily(data) {
  return request({
    url: 'system/memberFamily/deleteById',
    params: data,
    method: 'get'
  })
}
// 查询会员标签集
export function getMemberTag(data) {
  return request({
    url: 'system/memberLabel/list',
    params: data,
    method: 'get'
  })
}
// 查询会员标签集
export function queryUserIsHaveHighestRole(data) {
  return request({
    url: 'system/user/queryUserIsHaveHighestRole',
    params: data,
    method: 'get'
  })
}
// 获取指标检测-根据会员ID查询所有的检测记录
export function memberDailyEnergyBmiCheckList(params) {
  return request({
    url: `/system/memberDailyEnergyBmiCheck/list`,
    params,
    method: 'get'
  })
}
// 运动专属方案- 获取查询会员运动方案列表
export function memberExerciseSchemeList(params) {
  return request({
    url: '/system/memberExerciseScheme/list',
    method: 'get',
    params
  })
}
// 根据餐类查询千卡分组列表
export function getGroupKilocalorieValue(params) {
  return request({
    method: 'get',
    url: '/system/memberDietRecommend/getGroupKilocalorieValue',
    params
  })
}
// 获取餐名列表
export function memberDietRecommendList(data) {
  return request({
    url: '/system/memberDietRecommend/list',
    method: 'post',
    data
  })
}
// 获取积分兑换记录
export function integralExchangeOrderList(params) {
  return request({
    url: '/system/member-integral-exchange-order/listByPage',
    method: 'get',
    params
  })
}
// 获取运动列表数据
export function getExercise(data) {
  return request({
    url: '/system/memberExerciseRecommend/list',
    method: 'post',
    data
  })
}
// 拉取专属健康方案详情
export function getMemberHealthSchemeDetail(params) {
  return request({
    url: '/system/memberHealthScheme/detailByPc',
    method: 'get',
    params
  })
}
// 指标检测-根据会员ID、检测类型查询最新一次的检测结果
export function memberDailyEnergyBmiCheckGetOne(params) {
  return request({
    url: '/system/memberDailyEnergyBmiCheck/getOne',
    method: 'get',
    params
  })
}
// 工单-详情查询
export function workOrderDetail(params) {
  return request({
    url: '/system/workOrder/workOrderDetail',
    method: 'get',
    params
  })
}
// 随访记录-配置树列表
export function listTreeForHighPressure(params) {
  return request({
    url: '/system/follow-up-service-item-config/listTreeWithConfigForHighPressure',
    method: 'get',
    params
  })
}
//  查询随访记录详情
export function detailByBizCode(params) {
  return request({
    url: `/system/follow-up-service-record/detailByBizCode/${params}`,
    method: 'get',
    // params
  })
}
//高血压患者随访记录-新增或修改
export function saveOrUpdateRecord4HighBloodPressure(data) {
  return request({
    url: `/system/follow-up-service-record/saveOrUpdateRecord4HighBloodPressure`,
    method: 'post',
    data
  })
}
// 会员档案-详情
export function memberArchiveDetail(params) {
  return request({
    url: `/system/memberArchive/detail/${params}`,
    method: 'get'
  })
}
// 会员档案-新增编辑
export function saveOrUpdateRecord(data) {
  return request({
    url: `/system/member/updateMember`,
    method: 'post',
    data
  })
}
// 会员档案-配置树查询
export function listTreeWithConfig(params) {
  return request({
    url: `/system/memberArchiveNodeConfig/listTreeWithConfig`,
    method: 'get'
  })
}
// 会员档案-新增或修改
export function memberArchiveSaveOrUpdateRecord(data) {
  return request({
    url: `/system/member/updateMember`,
    method: 'post',
    data
  })
}
// 治疗历史-根据用户查询
export function memberTreatmentHistoryListByMember(params) {
  return request({
    url: `/system/memberTreatmentHistory/listByMember/${params}`,
    method: 'get',
    // params
  })
}
// 治疗历史-新增
export function memberTreatmentHistoryInsert(data) {
  return request({
    url: `/system/memberTreatmentHistory/insert`,
    method: 'post',
    data
  })
}
// 会员检查报告-根据用户查询
export function memberMedicExaminationReportListByMember(params) {
  return request({
    url: `/system/memberMedicExaminationReport/listByMember/${params}`,
    method: 'get',
    // params
  })
}
// 会员检查报告-新增
export function memberMedicExaminationReportInsert(data) {
  return request({
    url: `/system/memberMedicExaminationReport/insert`,
    method: 'post',
    data
  })
}
// 通过工单编号获取详情
export function workOrderDetailById(params) {
  return request({
    url: `/system/workOrder/workOrderDetail`,
    method: 'get',
    params
  })
}
// 获取慢病标签
export function memberLabelRelation(params) {
  return request({
    url: `/system/memberLabelRelation/listByMemberId`,
    method: 'get',
    params
  })
}
// 随访记录单独查询用户信息
export function userInfoById(params) {
  return request({
    url: `/system/member/getArchivesInfoById`,
    method: 'get',
    params
  })
}
// 季度报告-运营端-会员季度访问记录详情
export function memberQuarterlyDetail(params) {
  return request({
    url: `/system/memberQuarterlyFollowNodeRecord/detail/${params}`,
    method: 'get',
    // params
  })
}
// 季度报告-运营端-查询季度健康访问节点配置树列表
export function memberQuarterlyListTreeWithConfig(params) {
  return request({
    url: `/system/memberQuarterlyFollowNodeConfig/listTreeWithConfig/${params}`,
    method: 'get',
    // params
  })
}
// 季度报告-运营端-保存会员季度访问记录
export function memberQuarterlySaveRecord(data) {
  return request({
    url: `/system/memberQuarterlyFollowNodeRecord/saveRecord`,
    method: 'post',
    data
  })
}
// 获取疾病风险等级配置文案列表
export function memberQuarterlySummaryInfo(params) {
  return request({
    url: `/system/memberQuarterlySummaryInfo/getRiskLevelInfo`,
    method: 'get',
    params
  })
}
// 季度报告-运营端-保存季度总结信息
export function memberQuarterlySaveInfo(data) {
  return request({
    url: `/system/memberQuarterlySummaryInfo/saveInfo`,
    method: 'post',
    data
  })
}
// 季度报告-运营端-季度总结详情
export function memberQuarterlyInfoDetauil(params) {
  return request({
    url: `/system/memberQuarterlySummaryInfo/detail`,
    method: 'get',
    params
  })
}
// 获取所有慢病标签列表
export function getMemberLabelList(params) {
  return request({
    url: `/system/memberLabel/list`,
    method: 'get',
    params
  })
}
// 创建会员
export function createMember(data) {
  return request({
    url: `/system/member/createMember`,
    method: 'post',
    data
  })
}
// 获取所有门店列表
export function storeList(params) {
  return request({
    url: `/system/store/list`,
    method: 'get',
    params
  })
}
// 根据手机号码查询会员信息是否存在
export function getMemberInfoByPhoneNum(params) {
  return request({
    url: `/system/member/getMemberInfoByPhoneNum`,
    method: 'get',
    params
  })
}